module.exports = function(h, row) {
    if (row.status == 1) {
        return <span class="label green">Completed</span>;
    }

    return <span class="label yellow">In Progress</span>;
};



// WEBPACK FOOTER //
// ./resources/assets/js/components/stock_check/stock-check-list-status.jsx